<template>
  <footer class="minimal-footer">
    <div class="minimal-footer__container">
      <div class="minimal-footer__store-links">
        <div class="minimal-footer__logo-section">
          <router-link
            v-button-event
            to="/">
            <img
              src="@/assets/images/logo-new.svg"
              alt="Luminary Logo">
          </router-link>
        </div>
        <app-store-links />
      </div>
      <div class="minimal-footer__legal-links">
        <router-link
          v-button-event="{buttonName: 'Footer Terms of Service'}"
          to="/terms"
          aria-label="Terms of service"
        >Terms of Service</router-link>
        <router-link
          v-button-event="{buttonName: 'Footer Privacy Policy'}"
          to="/privacy"
          aria-label="Privay policy"
        >Privacy Policy</router-link>
        <span>&copy; {{ new Date().getFullYear() }} Luminary Media, LLC</span>
      </div>
    </div>
  </footer>
</template>
<script>
import AppStoreLinks from '@/components/AppStoreLinks';

export default {
  name: 'MLPFooter',
  components: {
    AppStoreLinks,
  },
};
</script>
<style lang='scss' scoped>
@import "../../../assets/scss/variables.scss";

$mm-light-title-color: #F3F1D5;
$mm-light-text-color: #F7F8DE;
$mm-dark-color: #89B1AA;
$mm-dark-background: #2F88A0;
$mm-light-background-color: #FFFFFA;

$mm-black-color: #0C132A;
$mm-almost-black: #121C30;

$max-width-threshold: 1280px;
.minimal-footer {
  border-top: 1px solid #343B4A;
  padding: 0 16px;
  &__container {
    max-width: $max-width-threshold;
    margin: 0 auto;
    text-align: right;
    @media (max-width: $sm) {
      text-align: center;
    }
  }
  &__store-links {
    display: flex;
    justify-content: space-between;
    @media (max-width: $sm) {
      justify-content: center;
    }
  }
  &__logo-section {
    margin: 34px 0 30px;
    @media (max-width: $sm) {
      display: none;
    }
    img {
      height: 43px;
      width: 178px;
      @media (max-width: $lg - 1) {
        height: 36px;
        width: 149px;
      }
      @media (max-width: $md - 1) {
        height: 32px;
        width: 132px;
      }
      @media (max-width: $sm - 1) {
        height: 32px;
        width: 132px;
      }
    }
  }
  &__legal-links {
    a {
      position: relative;
      color: $white;
      font-family: $clear-sans;
      font-size: 13.5px;
      letter-spacing: -0.17px;
      line-height: 32px;
      /* padding-right: 9px; */
      /* border-right: 1px solid white; */
      margin-right: 14px;
      &:after {
        content: '';
        position: absolute;
        width: 1px;
        height: 13px;
        background-color: white;
        bottom: 2px;
        right: -9px;
      }
      &:hover {
        color: $blue;
        border-bottom: 1px solid $blue;
      }
    }
    span {
      color: #666666;
      font-family: $clear-sans;
      font-size: 13.5px;
      letter-spacing: -0.18px;
      line-height: 32px;
      @media (max-width: $md - 1) {
        display: inline-block;
      }
    }
  }
}
</style>
